if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        // نفس مؤثرات الإضافة الموجودة في كروت المنتجات، لكن لصفحة المنتج.
        if (typeof window.unisonProductAddFeedback === 'function') {
          window.unisonProductAddFeedback(this.submitButton);
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              if (typeof window.unisonProductAddError === 'function') {
                window.unisonProductAddError(this.submitButton);
              }
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            this.error = false;

            // طلب الإضافة نجح فعليًا. استجابة cart/add.js لا تحتوي دائمًا على
            // إجمالي السلة أو عدد المنتجات، لذلك نقرأ cart.js مرة واحدة فقط هنا
            // لتشغيل نفس رسالة الشحن المجاني المستخدمة في الكوليكشنز.
            const triggerUnisonSuccess = () => {
              fetch(`${window.Shopify.routes.root}cart.js`, {
                headers: { Accept: 'application/json' },
                cache: 'no-store',
              })
                .then((cartResponse) => {
                  if (!cartResponse.ok) throw new Error('Cart state error');
                  return cartResponse.json();
                })
                .then((cart) => {
                  if (typeof window.unisonProductAddSuccess === 'function') {
                    window.unisonProductAddSuccess(cart, this.submitButton);
                  }
                })
                .catch((cartError) => {
                  // الإضافة نفسها نجحت، لذلك لا نحولها إلى Error لو فشل تحديث
                  // بيانات السلة؛ نعرض نجاحًا باستخدام الاستجابة المتاحة.
                  console.error(cartError);
                  if (typeof window.unisonProductAddSuccess === 'function') {
                    window.unisonProductAddSuccess(response, this.submitButton);
                  }
                });
            };

            if (!this.cart) {
              triggerUnisonSuccess();
              window.location = window.routes.cart_url;
              return;
            }

            triggerUnisonSuccess();

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure('add:paint-updated-sections', () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure('add:paint-updated-sections', () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            if (typeof window.unisonProductAddError === 'function') {
              window.unisonProductAddError(this.submitButton);
            }
            this.error = true;
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
